<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb 
          parentRouteName="BadgeCampaignList" 
          :extra-items="[
            {
              text: '徽章管理',
              to: 'BadgeListByBadgeCampaign',
              params: {
                merchantId: $route.params.merchantId,
                badgeCampaignId: $route.params.badgeCampaignId
              }
            },
            {
              text: badge.name,
              to: 'BadgeViewByBadgeCampaign',
              params: {
                merchantId: $route.params.merchantId,
                badgeCampaignId: $route.params.badgeCampaignId,
                badgeId: $route.params.badgeId
              }
            },
            {
              text: '會員列表'
            }
          ]" 
        />
      </div>
    </div>
    <b-overlay :show="isFetching">
      <b-card>
        <h4 class="mb-2 mb-xl-0 mr-2 font-weight-bold">{{ `已擁有${badge.name}徽章的會員` }}</h4>

        <div class="d-flex justify-content-end">
          <div>
            <StaffAddCustomer
              ref="staffAddCustomer"
              add-button-text="加入會員"
              @bind="bindCustomer"
            ></StaffAddCustomer>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <b-table
              striped
              hover
              responsive
              :items="customers"
              :fields="fields"
            >
              <template #cell(avatar_url)="data">
                <div class="d-flex align-items-center justify-content-center">
                  <router-link :to="{ name: 'CustomerDetailView', params: { customerID: data.item.id } }" >
                    <b-avatar
                      :src="data.item.avatar_url"
                      variant="secondary"
                      size="2rem"
                    ></b-avatar>
                  </router-link>
                </div>
              </template>
              <template #cell(name)="data">
                <router-link :to="{ name: 'CustomerDetailView', params: { customerID: data.item.id } }" >{{ data.item.name | hiddenString(20) }}</router-link>
              </template>
              <template #cell(action)="data">
                <div class="d-flex justify-content-center">
                  <b-button variant="inverse-danger" size="sm" @click="unbindCustomer(data.item)">
                    移除會員
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </div>

        <div class="d-flex justify-content-center" style="margin-top: 80px">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            @change="fetchCustomers"
          ></b-pagination>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { BAvatar } from "bootstrap-vue";
import badgeApi from "@/apis/badge";
import moment from "moment";
import StaffAddCustomer from "@/pages/Dashboard/Staff/StaffAddCustomer.vue";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  components: { BAvatar, StaffAddCustomer, BreadCrumb },

  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      isFetching: false,
      badge: {
        name: "",
      },
      customers: [],
      fields: [
        { key: "avatar_url", label: "" },
        { key: "name", label: "LINE 名稱" },
        { key: "outer_code", label: "平台ID" },
        { key: "mobile_phone", label: "手機" },
        { key: "email", label: "Email" },
        {
          key: "birthday",
          label: "生日",
          formatter: (value) => {
            return value ? moment(value).format('YYYY-MM-DD') : '';
          }
        },
        { key: 'action', label: '操作' },
    ],
    };
  },

  mounted() {
    this.fetchBadge()
    this.fetchCustomers()
  },

  methods: {
    async fetchBadge() {
      const { data } = await badgeApi.getBadge(
        this.$route.params.badgeId
      );
      this.badge = data.data
    },
    async fetchCustomers() {
      try {
        this.isFetching = true;
        const { data } = await badgeApi.getCustomers(this.$route.params.badgeId, {
          per_page: this.perPage,
          page: this.currentPage,
        });
        this.customers = data.data
        this.totalRows = data.meta.total
      } catch (e) {
        console.log(e)
      }
      this.isFetching = false
    },
    async bindCustomer(customer) {
      this.$swal({
        title: "確定要加入會員嗎",
        html: `
          <div class="d-block">
            <div class="my-3 text-left">
              <div>消費者姓名:${customer.name}</div>
            </div>
          </div>`,
        type: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "返回",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "確認加入",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.doBindCustomer(customer)
          } catch (e) {
            console.log(e)
          } finally {
            this.$refs.staffAddCustomer.refreshSearch()
            this.$refs.staffAddCustomer.closeModal()
          }
        }
      })
    },
    async doBindCustomer(customer) {
      this.isFetching = true
      try {
        await badgeApi.bindCustomer(this.$route.params.badgeId, customer.id)
        await this.fetchCustomers()
      } catch (error) {
        console.error(error);

        this.$swal(
          "加入失敗",
          `${customer.name} 加入失敗`,
          "warning"
        );
      }
      this.isFetching = false
    },
    async unbindCustomer(customer) {
      const result = await this.$swal({
        title: "移除會員",
        text: `確定要將 ${customer.name} 移除嗎?`,
        type: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "移除",
        reverseButtons: true,
      })
      if (! result.value) {
        return
      }

      this.isFetching = true
      try {
        await badgeApi.unbindCustomers(this.$route.params.badgeId, [customer.id])
        await this.fetchCustomers()
      } catch (error) {
        console.error(error);

        this.$swal(
          "解除失敗",
          `${customer.name} 解除失敗`,
          "warning"
        );
      }
      this.isFetching = false
    },
    goBackOrList() {
      if (this.$route.params.badgeCampaignId) {
        this.$router.push({
          name: "BadgeListByBadgeCampaign",
          params: {
            badgeCampaignId: this.$route.params.badgeCampaignId
          },
          query: this.routeQuery
        });
      }
      else {
        this.$router.push({ name: "BadgeList", query: this.routeQuery });
      }
    },
  },
};
</script>

<style></style>
